export default __webpack_public_path__ + "static/33F324_A_0-fe22e90402418664949e1ee2b111decd.ttf";